

class ClassBase {
  constructor(opts) {
    this.settings = Object.assign({}, opts);
  }

  appendTo(obj) {
    this.$html.appendTo(obj);
    return this;
  }

  show() {
    this.$html.show();
    return this;
  }

  hide() {
    this.$html.hide();
    return this;
  }

  remove() {
    this.$html.remove();
    return this;
  }
}
export default ClassBase;



// WEBPACK FOOTER //
// ./src/component/classBase.js